/*
 * @Description: 待开
 * @Date: 2020年12月14日12:55:33
 * @LastEditors: Please set LastEditors
 */
import { invoice } from '@/api/ajax';
import TableRenderClass from '@/components/tableRender/tableRenderClass';
import { moneyFixed } from '@/tools/money';
import dateFormat from '@/tools/dateFormat.js';
import { PAY_BANK_TYPE_KEY, PAY_TYPE_KEY } from '@/common/constants/bank';
import { bankRowLabelFiled, payTypeRowLabelFiled } from '@/common/fields/bank'; // 在这混入兼容方便兼容之前数据

const Enums = {
  payStatusEnum: {
    0: '未支付',
    1: '支付中',
    2: '支付成功',
    3: '支付失败'
  },
  payStatusEnum2: {
    0: '未支付',
    1: '支付中',
    2: '支付成功',
    3: '支付失败',
    4: '线下支付完成',
    5: '关闭支付'
  },
  collectMoneyType: {
    1: '银行卡',
    2: '钱包'
  }
};
const priceScale = (h, ctx, r, c) => {
  return h('span', r[c.property] + '%');
};
const priceRender = (h, ctx, r, c) => {
  return h('span', moneyFixed(+r[c.property]));
};
const dateRender = (h, ctx, r, c) => {
  return h('span', dateFormat(r[c.property]) || '-');
};

let table = new TableRenderClass({
  fields: {
    index: {
      width: '60px',
      label: '序号',
      type: 'index'
    },
    fullName: {
      label: '项目参与人',
      prop: 'fullName'
    },
    经营者: {
      label: '经营者',
      prop: 'fullName'
    },
    个体名称: {
      label: '个体',
      prop: 'userEnterpriseName'
    },
    userPhone: {
      label: '手机号',
      prop: 'userPhone'
    },
    bankNo: {
      label: '收款账号',
      prop: 'bankNo'
    },
    collectMoneyType: {
      label: '收款方式',
      prop: 'collectMoneyType',
      render: (h, ctx, r, c) => {
        return h('span', Enums.collectMoneyType[r[c.property]] || '-');
      }
    },
    projectName: {
      label: '项目名称',
      prop: 'projectName'
    },
    taskDt: {
      label: '任务月度',
      prop: 'taskDt'
    },
    finishSum: {
      label: '实际完成任务量',
      prop: 'finishSum'
    },
    taskPrice: {
      label: '终端结算单价',
      prop: 'taskPrice',
      render: priceRender
    },
    csoPriceSum: {
      label: '终端结算金额',
      prop: 'csoPriceSum',
      render: priceRender
    },
    personalScale: {
      label: '服务费率',
      prop: 'personalScale',
      render: priceScale
    },
    totalPrices: {
      label: '结算总价',
      prop: 'totalPrices',
      render: priceRender
    },
    payStatus: {
      label: '支付状态',
      prop: 'payStatus',
      render: function(h, ctx, r) {
        return h('span', Enums.payStatusEnum2[r.newPayStatus]);
      }
    },
    finishPayDt: {
      label: '到账时间',
      prop: 'finishPayDt',
      render: dateRender
    }
  }
});

let dakuanjine = table.createPart({
  name: '打款金额列表',
  list: invoice.amountOfMoney,
  requestNow: true,
  fields: [
    'index',
    'fullName', // 项目参与人
    'userPhone', // 手机号
    'bankNo', // 收款账号
    'projectName', // 项目名称
    'finishSum', // 实际完成任务量
    'taskPrice', // 终端结算单价
    'csoPriceSum', // 终端结算金额
    'personalScale', // 服务费率
    'totalPrices', // 结算总价
    'payStatus', // 支付状态
    bankRowLabelFiled[PAY_BANK_TYPE_KEY], // 支付通道
    payTypeRowLabelFiled[PAY_TYPE_KEY],
    'finishPayDt' // 到账时间
  ]
});
let dakuanjineGeti = table.createPart({
  name: '打款金额列表（个体）',
  list: invoice.amountOfMoney,
  requestNow: true,
  fields: [
    'index',
    '个体名称', // 个体名称
    '经营者', // 项目参与人 -> 经营者
    'userPhone', // 手机号
    'bankNo', // 收款账号
    'projectName', // 项目名称
    'finishSum', // 实际完成任务量
    'taskPrice', // 终端结算单价
    'csoPriceSum', // 终端结算金额
    'totalPrices', // 结算总价
    'payStatus', // 支付状态
    bankRowLabelFiled[PAY_BANK_TYPE_KEY], // 支付通道
    payTypeRowLabelFiled[PAY_TYPE_KEY],
    'finishPayDt' // 到账时间
  ]
});
let dakuanjineWeiTuo = table.createPart({
  name: '打款金额列表',
  list: invoice.amountOfMoney,
  requestNow: true,
  fields: [
    'index',
    'fullName', // 项目参与人
    'userPhone', // 手机号
    'bankNo', // 收款账号
    'projectName', // 项目名称
    'finishSum', // 实际完成任务量
    'taskPrice', // 终端结算单价
    'csoPriceSum', // 终端结算金额
    'totalPrices', // 结算总价
    'payStatus', // 支付状态
    bankRowLabelFiled[PAY_BANK_TYPE_KEY], // 支付通道
    payTypeRowLabelFiled[PAY_TYPE_KEY],
    'finishPayDt' // 到账时间
  ]
});
// 委托个体
let dakuanjineWeiTuoGeti = table.createPart({
  name: '打款金额列表',
  list: invoice.amountOfMoney,
  requestNow: true,
  fields: [
    'index',
    '个体名称', // 个体名称
    '经营者', // 项目参与人 -> 经营者
    'userPhone', // 手机号
    'bankNo', // 收款账号
    'projectName', // 项目名称
    'finishSum', // 实际完成任务量
    'taskPrice', // 终端结算单价
    'csoPriceSum', // 终端结算金额
    'totalPrices', // 结算总价
    'payStatus', // 支付状态
    bankRowLabelFiled[PAY_BANK_TYPE_KEY], // 支付通道
    payTypeRowLabelFiled[PAY_TYPE_KEY],
    'finishPayDt' // 到账时间
  ]
});
// 打款金额
export const dakuan = [{ name: '待开票订单', childMenu: [dakuanjine] }];
// 打款金额 个体
export const dakuanGeti = [
  { name: '打款金额（个体）', childMenu: [dakuanjineGeti] }
];
// 打款金额 委托
export const dakuanWT = [
  { name: '打款金额（委托）', childMenu: [dakuanjineWeiTuo] }
];
// 打款金额 委托个体
export const dakuanWTGeti = [
  { name: '打款金额 (委托个体)', childMenu: [dakuanjineWeiTuoGeti] }
];
